import type { PropsWithChildren } from "react"
import { Stack, Switch, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    header: {
        cursor: "pointer",
    },
    title: {
        fontWeight: 600,
        color: theme.palette.tailwind.slate[600],
    },
    description: {
        color: theme.palette.tailwind.slate[500],
    },
}))

type SalesRuleRowProps = Readonly<
    PropsWithChildren<{
        title: string
        description: string
        checked: boolean
        onCheckChange: (checked: boolean) => void
    }>
>

export function SalesRuleRow({ title, description, checked, onCheckChange, children }: SalesRuleRowProps) {
    const { classes } = useStyles()

    return (
        <Stack spacing="1.25rem">
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing="1rem"
                className={classes.header}
                onClick={() => onCheckChange(!checked)}
            >
                <Stack>
                    <Typography variant="subtitle1" className={classes.title}>
                        {title}
                    </Typography>
                    <Typography variant="body2" className={classes.description}>
                        {description}
                    </Typography>
                </Stack>
                <Switch
                    checked={checked}
                    onChange={(_, state) => onCheckChange(state)}
                    onClick={(event) => event.stopPropagation()}
                />
            </Stack>
            {checked && children}
        </Stack>
    )
}
